export const providersImages = [
  {
    shortName: "firekirin",
    image: "fire-kirin.png",
    imageTitle: "fire-kirin-title.png",
    imageSlide: "fire-kirin-slide.png",
    titleHeight: 1.7,
    imgWidth: 130,
    bRadius: '0'
  },
  {
    shortName: "juwa",
    image: "juwa.png",
    imageTitle: "juwa-title.png",
    imgWidth: 140,
    titleHeight: 2.2,
    titleLeft: 47,
    imgHeight: 140,
    imgTop: -38.5,
    imgLeft: 58.5,
    bRadius: '0'
  },
  {
    shortName: "panda",
    image: "panda.png",
    imageTitle: "panda-title.png",
    titleLeft: 44
  },
  {
    shortName: "river",
    image: "river.png",
    imageTitle: "river-title.png",
    imageSlide: "river-slide.png",
    titleHeight: 1,
    titleLeft: 39,
  },
  {
    shortName: "senet",
    image: "pyramyd.png",
    imageTitle: "pyramyd-title.png",
    imageSlide: "pyramyd-slide.png",
    imgWidth: 150,
    imgHeight: 150,
    imgTop: -32.5,
    bRadius: '0',
    titleHeight: 2.1,
    titleLeft: 39,
  },
  {
    shortName: "ultrapanda",
    image: "ultra-panda.png",
    imageTitle: "ultra-panda-title.png",
    imgWidth: 115,
    bRadius: '0',
    titleHeight: 2.4,
    titleLeft: 44,
  },
  {
    shortName: "vblink",
    image: "vblink.png",
    imageTitle: "vblink-title.png",
    imgWidth: 105,
    bRadius: '0',
    titleLeft: 39,
  },
  {
    shortName: "gd",
    image: "gd.png",
    imageTitle: "gd-title.png",
    imageSlide: "gd-slide.png",
    imgWidth: 105,
    titleHeight: 1,
    titleLeft: 37,
  }
];
